import { ProductLine } from "@/types/common";

/**
 * Core helper that evaluates a list of items and extracts the unified ProductLine
 */
export const deriveProductLine = <T>(
  items: T[],
  genderExtractor: (item: T) => string[] | string | undefined | null
): ProductLine => {
  if (!items || items.length === 0) {
    return undefined;
  }

  const uniqueGenders = new Set<string>();

  for (const item of items) {
    const rawGender = genderExtractor(item);
    if (!rawGender) continue;

    // Handle both single strings and arrays of strings smoothly
    const genders = Array.isArray(rawGender) ? rawGender : [rawGender];

    for (const g of genders) {
      if (g) uniqueGenders.add(g.toLowerCase());
    }
  }

  // If no gender data was found at all
  if (uniqueGenders.size === 0) return undefined;

  // Only "men" exists
  if (uniqueGenders.has("men") && uniqueGenders.size === 1) {
    return "men";
  }

  // Only "women" exists
  if (uniqueGenders.has("women") && uniqueGenders.size === 1) {
    return "women";
  }

  // Mixed ("men" + "women"), "all", or other
  return "neutral";
};
